import { BottomFixedModal } from "@src/shared/src";

type Props = {
  isTransition?: boolean;
  transitionEndCallback?: () => void;
  touchEventCallback?: () => void;
  isShow: boolean;
  hideModal: () => void;
  title: string;
  children: React.ReactNode;
  style?: any;
};
export default function HallSearchFixedBottomSheet({
  isTransition = false,
  transitionEndCallback,
  touchEventCallback,
  isShow,
  hideModal,
  title,
  children,
  style,
}: Props) {
  return (
    <BottomFixedModal
      isTransition={isTransition}
      isShow={isShow}
      hideModal={hideModal}
      title={title}
      hasCloseButton={true}
      closeButtonPosition="title"
      modalStyle={{ minHeight: "90vh", maxHeight: "90vh", height: "90vh" }}
      contentStyle={style}
      hasInnerScroll={true}
    >
      {children}
    </BottomFixedModal>
  );
}
